import { Channel } from "../common/transmit";
import { Lang } from "@antv/x6";
import { CustomEventTypeEnum, StoreKey } from "../common/enums";

function getTargetByNode(node) {
  const { data = {} } = node
  const label = node.data.tooltip
  const { actionType, jobType, jobCode } = data
  return { node, label, nodeId: node.id, actionType, jobType, jobCode }
}

function getStore(key) {
  return window[key]
}

export default (graph) => {
  // 画布空白区域单击
  graph.on('blank:click', () => {
    Channel.dispatchEvent(CustomEventTypeEnum.BLANK_CLICK)
  });
  // 单击
  graph.on('node:click', ({ node }) => {
    const detail = getTargetByNode(node)
    Channel.dispatchEvent(CustomEventTypeEnum.NODE_CLICK, detail)
  });
  // 双击
  graph.on('node:dblclick', ({ node }) => {
    const cells = graph.getSelectedCells()
    if (Lang.isArray(cells) && cells.length === 1) {
      const detail = getTargetByNode(node)
      const graph = getStore(StoreKey.GRAPH)
      const edges = graph.getEdges()
      let sourceId = '';
      for (const edge of edges) {
        if (edge.target.cell === node.id) {
          sourceId = edge.source.cell
          break;
        }
      }
      Channel.dispatchEvent(CustomEventTypeEnum.DOUBLE_NODE_CLICK, {...detail, parentNodeId:sourceId})
    }
  });
}
